import { LngLat, LngLatBounds, Map, NavigationControl } from 'maplibre-gl';
import CC from '@/cc';
import ky from 'ky';

function addAwsGatewayAuth(urlString) {
  if (urlString.includes('?')) {
    urlString += '&';
  } else {
    urlString += '?';
  }

  urlString += `api_key=${import.meta.env.VITE_COALITIONS_BASE_MAPS_NLR_API_KEY}`;
  if (!urlString.includes('_app_id=')) {
    urlString += `&_app_id=${import.meta.env.VITE_COALITIONS_BASE_MAPS_APP_ID}`;
  }

  return urlString;
}

function transformStyle(previousStyle, nextStyle) {
  const style = nextStyle;
  if (style?.sources?.aws && style?.layers) {
    // Add our own api.data.gov API key and _app_id for calling AWS stuff via our gateway layer.
    if (style.sprite) {
      style.sprite = addAwsGatewayAuth(style.sprite);
    }
    if (style.glyphs) {
      style.glyphs = addAwsGatewayAuth(style.glyphs);
    }
    if (style.sources.aws.tiles) {
      style.sources.aws.tiles = style.sources.aws.tiles.map((tile) =>
        addAwsGatewayAuth(tile),
      );
    }

    // Unset the `projection` field so MapLibre will always use the default
    // mercator projection even if AWS returns a `globe` projection.
    delete style.projection;
  }
  return style;
}

(function() {

  var $self = this;
  $self.Coalitions      = $self.Coalitions      || {};
  $self.Coalitions.show = $self.Coalitions.show || {};

  $self.Coalitions.show.map = (function() {
    var pub = {};

    var map;

    pub.init = async function(params) {
      map = new Map({
        container: 'coalition-show-map',
        attributionControl: {
          compact: false,
        },
        minZoom: 1,
        maxZoom: 18,
        validateStyle: import.meta.env.MODE !== 'production',
      });

      map.addControl(new NavigationControl({
        showCompass: false,
      }), 'top-left');

      const res = await _fetchCoalitionData(params.coalitionId);

      // Zoom to bounds before rendering map to prevent rendering of map at 0/0
      // lat lng before jumping to real location.
      _setBounds(res.result.shapes_envelope, params.coalitionId);

      _renderMap();

      map.on('load', async () => {
        _renderShape(res.result.shapes);
      });
    };

    async function _fetchCoalitionData(coalitionId) {
      return await ky(`${import.meta.env.VITE_INTERNAL_SHAMWOW_API_URL_ROOT}/v1/coalitions/${coalitionId}/geojson`, {
        searchParams: {
          api_key: import.meta.env.VITE_INTERNAL_SHAMWOW_CLIENT_SIDE_NLR_API_KEY,
        },
      }).json();
    }

    function _setBounds(envelope, id) {
      const bounds = new LngLatBounds();
      // hardcoding in Alaska bounds that will not throw off map
      if (id === 134) {
        const alaskaSW = new LngLat(-179.1505, 51.2097);
        const alaskaNE = new LngLat(-129.9795, 71.4410);
        bounds.extend(alaskaSW);
        bounds.extend(alaskaNE);
      } else {
        for (const coords of envelope.coordinates[0]) {
          bounds.extend(coords);
        }
      }

      map.fitBounds(bounds, {
        duration: 0,
        padding: 24,
      });
    }

    function _renderShape(shape) {
      map.addSource('coalition', {
        type: 'geojson',
        data: shape,
      });

      map.addLayer({
        id: 'coalition-fill',
        source: 'coalition',
        type: 'fill',
        paint: {
          'fill-color': '#3388ff',
          'fill-opacity': 0.2,
        },
      });

      map.addLayer({
        id: 'coalition-line',
        source: 'coalition',
        type: 'line',
        paint: {
          'line-color': '#3388ff',
          'line-width': 2,
        },
      });
    }

    function _renderMap() {
      const style = 'Standard';
      const colorScheme = 'Light';
      map.setStyle(addAwsGatewayAuth(`https://developer.nlr.gov/api/tada/amazon-location-service/maps/v2/styles/${style}/descriptor?color-scheme=${colorScheme}`), {
        transformStyle,
      });
    }

    return pub;
  })();

}).call(CC);
